import { ref, computed } from '@vue/composition-api';

export const isKeepAlive = ref(true); // 默认不缓存
export const keepAliveInclude = computed(() => (isKeepAlive.value ? ['index'] : []));
export function setIsKeepAlive(value) {
  isKeepAlive.value = value;
}
